import axios from "axios";

export default {
    getEmailIntegrations: async (companyId) => {
        const { data } = await axios.get(`/email_integrations/${companyId}`)

        return data
    },
    saveEmailIntegration: async (
        email_automation_id,
        integration_type,
        visibility,
        email,
        reply_to_email,
        sender_name,
        owner_id,
        company_id,
        default_address,
        smtp
    ) => {
        const id = email_automation_id ? email_automation_id : 0

        const { data } = await axios.post(`/email_integration/${id}`, {
            integration_type,
            visibility,
            email,
            reply_to_email,
            sender_name,
            owner_id,
            company_id,
            default_address,
            smtp: smtp ? {
                email_server: smtp['email_server'],
                password: smtp['password'],
                host: smtp['host'],
                port: smtp['port'],
                security: smtp['security'],
                default_smtp_server_for_company: smtp['default_smtp_server_for_company']
            } : null
        })

        return data
    },
    deleteEmailIntegration: async (email_automation_id) => {
        const { data } = await axios.delete(`/email_integration/${email_automation_id}`)

        return data
    },
    sendTestEmail: async (emailIntegrationId, integrationType, companyId, host, port, email, password, security, senderName) => {
        const { data } = await axios.post(`/email_automation/test_email/${companyId}`, {
            email_integration_id: emailIntegrationId,
            integration_type: integrationType,
            host,
            port,
            email,
            password,
            security,
            sender_name: senderName
        })

        return data
    },
    getDefaultSmtpData: async (companyId) => {
        const { data } = await axios.get(`/email_automation/default_smtp/${companyId}`)

        return data
    },
    saveDefault: async (companyId, emailIntegrationId, enabled) => {
        const { data } = await axios.post(`/email_automation/default/${companyId}`, {
            email_integration_id: emailIntegrationId,
            default_address: enabled
        })

        return data
    }
}